import { AUTH_ROLE_LABELS, AuthRole } from '../../../utils/roles';

/** Every role an account can hold, most access first. */
export const ROLE_OPTIONS: AuthRole[] = ['admin', 'hr', 'manager', 'jr_ae', 'employee'];

/** One line on what each role can do, shown beside role pickers and in confirmations. */
export const ROLE_SUMMARY: Record<AuthRole, string> = {
  admin: 'Full system control',
  hr: 'People operations access',
  manager: 'Team approvals and views',
  jr_ae: 'Approvals and views for assigned people',
  employee: 'Read-only floor plan and org chart',
};

export const roleLabel = (role: AuthRole | null | undefined) => AUTH_ROLE_LABELS[role ?? 'employee'];

/** Settings (`/admin`) is open to these roles; anyone else sees “Access restricted”. */
export const SETTINGS_ROLES: AuthRole[] = ['admin', 'hr'];
